import Uri from 'urijs';

export const getNonWwwHostname = (url: string): string => {
  return new Uri(url).hostname().replace(/^www\./, '');
};
